module.exports = __webpack_public_path__ + "static/media/view indent form.e465ab5c.svg";